import { render, staticRenderFns } from "./ItemDetailLicenseLayout.vue?vue&type=template&id=dfb50b56&scoped=true"
import script from "./ItemDetailLicenseLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailLicenseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb50b56",
  null
  
)

export default component.exports